import * as React from 'react';
import { Button, Text, Image, Flex, Segment, Loader, Card, CardHeader, CardBody, Header, OpenOutsideIcon, Tooltip, Dialog, LinkIcon, ArrowRightIcon, List, MegaphoneIcon, Label, InfoIcon, ParticipantAddIcon, AttendeeIcon, TenantPersonalIcon, Checkbox, Divider, Form, PaperclipIcon, FilesPictureColoredIcon, FilesHtmlColoredIcon, FilesPdfIcon, WordColorIcon, ExcelColorIcon, PowerPointColorIcon, OneNoteColorIcon, FilesEmptyIcon, Attachment, Avatar, ContactGroupIcon, CalendarIcon, SpeakerPersonIcon, ContentIcon, FormInput, FormButton, FormRadioGroup, Skeleton, NotesIcon } from '@fluentui/react-northstar';
import {app} from '@microsoft/teams-js';
import * as $ from 'jquery';
import { CaseType } from '../helpers/constants';
import * as Functions from '../helpers/Functions';
import axios from 'axios';
import { HttpRequest, RequestHeaders } from '../helpers/HttpRequest';
import { Helpers } from '../helpers/Helpers';
var noteTitle = '';
var fullOrSync = 'full';
var teamId;
var channelId;
var channelName;
var dialogMessage;
var channelFiles = [];
class ChannelTabComponent extends React.Component<ITabProps, ITabState> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true, loaderLabel: '', openDialog: false, type: '', caseInfo: { type: '', id: '' }, caseData: null,
            validChannel: true, invalidityReasson: null, isSendingConversations: false, isLoadingFiles: true, didAnyFileSelected: false, isSendingFiles: false,
            filesStatus: 'No Files in this Channel'
        }
        this.handleErrorResponse = this.handleErrorResponse.bind(this);
        this.handleSubmitExpConversation = this.handleSubmitExpConversation.bind(this);
        this.handleFilesSelectionChanged = this.handleFilesSelectionChanged.bind(this);
        this.handleSubmitExpFiles = this.handleSubmitExpFiles.bind(this);
    }
    componentDidMount() {
        app.getContext()
        .then(context => {
            teamId = context.team.internalId;
            channelId = context.channel.id;
            channelName = context.channel.displayName;
            this.retrieveCaseIdFromChannelId(context.channel.id, context.channel.displayName);
        })
        .catch(error => {
            console.error('Error loading channel details: ' + JSON.stringify(error));
            this.setState({
                validChannel: false
            })
        })
    }
    handleSubmitExpFiles(e, props) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isSendingFiles: true });
        var self = this;
        var filesId = [];
        channelFiles.forEach(file => {
            if (file.checked)
                filesId.push(file.id);
        });
        var url = "Setup/ExportChannelFiles";
        var model = { filesID: filesId, isContract: this.state.caseInfo.type == CaseType.contract };
        $.post(url, model, function (response) {
            try {
                let data = JSON.parse(response);
                let apiUrl = data.url;                
                let dataToPost = data.data;
                let files = data.files;
                let filesRequests = files.map(file => axios.get(file.downloadUrl, { responseType: 'blob' }));
                Promise.all(filesRequests)
                    .then(filesResponse => {
                        let filesToBeSend = [];
                        filesResponse.map((f, index) => {
                            let ff = f as any;
                            if (ff?.status === 200) {
                                let fData = ff?.data;
                                var file = new File([fData], files[index].file.Name);
                                filesToBeSend.push(file)
                            }
                        })
                        let caseType = dataToPost.split('=')[0];
                        let caseValue = dataToPost.split('=')[1];
                        let formData = new FormData();
                        formData.append(caseType, caseValue);
                        filesToBeSend.forEach((ftbS, index) => {
                            formData.append(`file_${index + 1}`, ftbS)
                        })
                        HttpRequest.post(apiUrl, formData)
                            .then(response => {
                                if (response.status === 200) {
                                    let error = response.data?.error;
                                    if (error != '') {
                                        dialogMessage = JSON.stringify(error);
                                    }
                                    else {
                                        let msg = response.data?.success?.msg;
                                        dialogMessage = msg;
                                    }
                                    self.setState({ isSendingFiles: false, openDialog: true });
                                }
                            })
                            .catch(error => {
                                dialogMessage = JSON.stringify(error);
                                self.setState({ isSendingFiles: false, openDialog: true });
                            })
                    })
                    .catch(error => {
                        dialogMessage = JSON.stringify(error);
                        self.setState({ isSendingFiles: false, openDialog: true });

                    })
            }
            catch (error) {
                if (response == "Error")
                    dialogMessage = "Something went wrong, please try again later";
                else {
                    dialogMessage = response;
                }
                self.setState({ isSendingFiles: false, openDialog: true });
            }
        });
    }
    handleSubmitExpConversation(e, props) {
        var self = this;
        this.setState({ isSendingConversations: true });
        let url = '/Setup/ExportChannelMessages';
        var model = { teamId: teamId, channelId: channelId, channelName: channelName, noteTitle: noteTitle, isFullConversation: (fullOrSync == 'full'), isContract: (this.state.caseInfo.type == CaseType.contract) };
        $.post(url, model, function (response) {
            if (typeof response === 'string') {
                switch (response) {
                    case "NotFound": {
                        dialogMessage = "Something went wrong, please try again later!";
                    } break;
                    case "Updated": {
                        dialogMessage = "No new messages found!";
                    } break;
                    case "NotSupported": {
                        dialogMessage = "Notes for this type not supported yet!";
                    } break;
                    default: {
                        dialogMessage = "Channel conversation exported successfully";
                    }
                }
                self.setState({ openDialog: true, isSendingConversations: false });
            }
            else {
                if (response) {
                    if (response.url && response.data) {
                        HttpRequest.post(response.url, response.data)
                            .then(response => {
                                let error = response.data?.error;
                                if (error != '') {
                                    dialogMessage = error;
                                }
                                else {
                                    let success = response.data?.success;
                                    dialogMessage = success?.msg ?? "Channel conversation exported successfully";
                                }
                                self.setState({ openDialog: true, isSendingConversations: false });
                            })
                            .catch(error => {
                                dialogMessage = JSON.stringify(error);
                                self.setState({ openDialog: true, isSendingConversations: false });
                            })
                    }
                }
            }
        });
    }
    handleFilesSelectionChanged(e, props) {
        try {
            var items = channelFiles;
            var anyFileSelected = false;
            for (let i = 0; i < items.length; i++) {
                if (props.label.trim() == items[i].header.props.label.trim()) {
                    items[i].checked = props.checked;
                }
                if (items[i].checked) {
                    anyFileSelected = true;
                }
            }
            channelFiles = items;
            this.setState({ didAnyFileSelected: anyFileSelected });
        }
        catch (err) {
            console.log(err);
        }
    }
    async handleErrorResponse(error, callBack) {
        if (error == 'Invalid Record') {
            this.setState({
                validChannel: false,
                invalidityReasson: 'invalidRecord'
            });
        }
        else {
            if (error?.code == "refresh_key_required") {
                await HttpRequest.refreshToken();
            } else if (error?.code == "unauthorized") {
                HttpRequest.userUnauthorized();
            }
            else {
                this.setState({
                    validChannel: false,
                    invalidityReasson: 'invalidRecord'
                });
            }
        }
    }
    async retrieveCaseIdFromChannelId(channelId, channelName) {
        var url = '/Setup/RetriveCaseIdFromChannelId';
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }
        let params = new URLSearchParams();
        params.append('channelId', channelId);
        params.append('channelName', channelName);
        axios.post(url, params, config).then((resp) => {
            try {
                if (resp.data.caseId != null) {
                    var type = resp.data.teamName.split('-')[1];
                    this.setState({ caseInfo: { type: type, id: resp.data.caseId }, isLoading: false, validChannel: String(resp.data.caseId).length > 0 });
                    if (resp.data.caseId.length > 0) {
                        this.getChannelFiles();
                    }                    
                    var caseData;
                    if (resp.data.caseId.length > 0) {
                        switch (type) {
                            case CaseType.litigation: case CaseType.matter: {
                                let apiUrl = '/modules/api/cases/edit/' + resp.data.caseId;
                                HttpRequest.get(apiUrl)
                                    .then(async response => {
                                        var resp = response.data;
                                        var error = resp.error;
                                        var success = resp.success;
                                        if (error) {
                                            this.handleErrorResponse(error, null);
                                            return;
                                        }
                                        if (success) {
                                            caseData = success.data.caseValues;
                                            const priorities = success.data.formData.priorities;
                                            Object.entries(priorities).map(([key, value]) => {
                                                if (key === caseData.priority) {
                                                    caseData.priorityId = caseData.priority;
                                                    caseData.priority = value;
                                                }
                                            });
                                            const assignedTeams = success.data.formData.provider_groups;
                                            assignedTeams.forEach(team => {
                                                Object.entries(team).map(([key, value]) => {
                                                    if (key === 'id' && value === caseData.provider_group_id)
                                                        caseData.provider_group_id = team.name;
                                                });
                                            });
                                            const caseTypes = success.data.formData.case_types;
                                            caseTypes.forEach(team => {
                                                Object.entries(type).map(([key, value]) => {
                                                    if (key === 'id' && value === caseData.case_type_id)
                                                        caseData.case_type_id = type.name;
                                                });
                                            });
                                            const caseStages = success.data.formData.caseStages;
                                            caseStages.forEach(stage => {
                                                Object.entries(stage).map(([key, value]) => {
                                                    if (key === 'id' && value === caseData.stage)
                                                        caseData.stage = stage.name;
                                                });
                                            });
                                            const defaultCurrency = success.data.formData.default_values.caseValueCurrency;
                                            caseData.currency = defaultCurrency;
                                            const clientId = caseData.contact_company_id;
                                            const isClientContact = caseData.clientType === 'contact';
                                            if (isClientContact) {
                                                try {
                                                    const response = await HttpRequest.get('/modules/api/contacts/edit/' + clientId);
                                                    if (response) {
                                                        const data = response.data?.success?.data?.contactValues;
                                                        if (data) {
                                                            caseData.clientEmail = data.email;
                                                            caseData.clientPhoneNumber = data.phone;
                                                            caseData.clientMobileNumber = data.mobile;
                                                        }
                                                    }
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                            else {
                                                try {
                                                    const response = await HttpRequest.get('/modules/api/companies/edit/' + clientId);
                                                    if (response) {
                                                        const data = response.data?.success?.data?.company_addresses;
                                                        if (data) {
                                                            const addr1 = data[0];
                                                            caseData.clientEmail = addr1.email;
                                                            caseData.clientPhoneNumber = addr1.phone;
                                                            caseData.clientMobileNumber = addr1.mobile;
                                                        }
                                                    }
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                            this.setState({ caseData: caseData });
                                        }
                                    });
                            } break;
                            case CaseType.hearing: {                                                         
                                HttpRequest.get('/modules/api/hearings/edit/' + resp.data.caseId)
                                    .then(response => {
                                        var resp = response.data;
                                        var error = resp.error;
                                        var success = resp.success;
                                        if (error) {
                                            this.handleErrorResponse(error, null);
                                            return;
                                        }
                                        if (success) {
                                            var caseValues = success.data.hearingValues;
                                            this.setState({ caseData: caseValues });
                                        }
                                    });
                            } break;
                            case CaseType.contract: {                                
                                HttpRequest.get('/modules/api/contracts/edit/' + resp.data.caseId)
                                    .then(response => {
                                        var resp = response.data;
                                        var error = resp.error;
                                        var success = resp.success;
                                        if (error) {
                                            this.handleErrorResponse(error, null);
                                            return;
                                        }
                                        if (success) {
                                            var caseValues = success.data.contract?.contract;
                                            var contract = success.data.contract;
                                            var contributorsArray = contract.contributors;
                                            var collaboratorsArray = contract.collaborators;
                                            const priorities = success.data.priorities;
                                            Object.entries(priorities).map(([key, value]) => {
                                                if (key === caseValues.priority) {
                                                    caseValues.priorityId = caseValues.priority;
                                                    caseValues.priority = value;
                                                }
                                            });
                                            var contributors = '';
                                            contributorsArray.forEach((item, index) => {
                                                contributors = contributors.concat(item.name.trim(), (index == contributorsArray.length - 1) ? '' : ', ');
                                            });
                                            var collaborators = '';
                                            collaboratorsArray.forEach((item, index) => {
                                                collaborators = collaborators.concat(item.name.trim(), (index == collaboratorsArray.length - 1) ? '' : ', ');
                                            })
                                            caseData = {
                                                'id': caseValues.id,
                                                'name': caseValues.name,
                                                'summary': caseValues.summary,
                                                'type': caseValues.type,
                                                'priority': caseValues.priority,
                                                'priorityId': caseValues.priorityId,
                                                'currency': caseValues.currency,
                                                'assignedTeam': caseValues.assigned_team,
                                                'assignee': caseValues.assignee,
                                                'parties': contract.parties,
                                                'collaborators': collaborators,
                                                'contributors': contributors,
                                                'referenceNumber': caseValues.reference_number,
                                                'value': caseValues.value,
                                                'status': caseValues.status,
                                                'requester': caseValues.requester,
                                                'contractDate': caseValues.contract_date,
                                                'startDate': caseValues.start_date,
                                                'endDate': caseValues.end_date
                                            }
                                            this.setState({ caseData: caseData });
                                        }
                                    });
                            } break;
                        }
                    }
                }
                else {
                    this.setState({ isLoading: false, validChannel: false });
                }
            }
            catch (err) {
                console.log(err);
                this.setState({ caseInfo: { type: '', id: '' }, isLoading: false, validChannel: false });
            }
        });
    }
    getChannelFiles() {
        var filesUrl = '/Setup/GetChannelFiles';
        var model = { teamId: teamId, channelId: channelId, channelName: channelName };
        var self = this;
        $.post(filesUrl, model, function (response) {
            if (response == 'error') {
                self.setState({ filesStatus: 'No files are available at this moment! Try to initialiaze the channel files by entering the Files tab. ' });
            }
            else {
                try {
                    channelFiles = [];
                    var parsedResponse = JSON.parse(response);
                    parsedResponse.forEach((item, index) => {
                        var imgSource;
                        var mimeType = "";
                        const styles = { width: '25px', height: '25px', paddingTop: '4px' };

                        if (item.File != null)
                            mimeType = item.File.MimeType;
                        else {
                            if (item.Package != null)
                                mimeType = item.Package.Type;
                        }
                        if (mimeType.length > 0) {
                            if (mimeType.includes("image/"))
                                imgSource = <FilesPictureColoredIcon styles={styles} />;
                            else {
                                switch (mimeType) {
                                    case "text/html": imgSource = <FilesHtmlColoredIcon styles={styles} />; break;
                                    case "application/pdf": imgSource = <FilesPdfIcon styles={styles} />; break;
                                    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                                        imgSource = <WordColorIcon styles={styles} />; break;
                                    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                                        imgSource = <ExcelColorIcon styles={styles} />; break;
                                    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                                        imgSource = <PowerPointColorIcon styles={styles} />; break;
                                    case "oneNote":
                                        imgSource = <OneNoteColorIcon styles={styles} />; break;
                                    default:
                                        imgSource = <FilesEmptyIcon styles={styles} />; break;
                                }
                            }
                        }
                        var initialName = item.Name;
                        var split = initialName?.split('.');
                        var filename = split[0];
                        var extension = split[1];
                        if (filename.length > 25) {
                            filename = filename.substring(0, 23) + '..';
                        }
                        var resultName = filename + '.' + extension;
                        channelFiles.push({
                            key: index,
                            icon: imgSource,
                            header: <Checkbox label={resultName} disabled={(parseFloat((((item.Size) / 1024) / 1024).toFixed(1))) > 50} onChange={self.handleFilesSelectionChanged} />,
                            description: item.Size / 1024 > 1024 ? (((item.Size) / (1024 * 1024)).toFixed(2) + 'MB') : (Math.trunc(item.Size / 1024) + 'KB'),
                            id: item.Id,
                            checked: false
                        });
                    });
                }
                catch (err) {
                    console.log(err);
                }
            }
            self.setState({ isLoadingFiles: false });
        });
    }
    render() {
        const items = [
            {
                name: 'full',
                key: 'Full',
                label: 'All Conversations',
                value: 'full',
            },
            {
                name: 'sync',
                key: 'Sync',
                label: 'Newest Conversations',
                value: 'sync',
            },
        ];
        const caseForm = () => {
            switch (this.state.caseInfo.type) {
                case CaseType.litigation: case CaseType.matter: {
                    return <Flex column hAlign='center' vAlign='center'>
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<InfoIcon />}
                                        label={this.state.caseInfo.type}
                                        name="General Info"
                                    />
                                    <Flex column>
                                        <Text content="General Info" weight="bold" />
                                        <Text content={this.state.caseInfo.type} size="small" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='ID: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.id} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Subject: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.subject} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Description: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.description} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Priority: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <div>
                                                {this.state.caseData.priorityId !== undefined && <Image src={require('../Images/' + this.state.caseData.priorityId + '.png')} styles={{ width: '20px', height: '20px' }} />}
                                                <Text content={this.state.caseData.priority} />
                                            </div>
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Workflow Status: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.status} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Practice Area: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.case_type_id} />
                                        </Flex.Item>
                                    </Flex>
                                    {/*<Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Stage: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.stage} />
                                        </Flex.Item>
                </Flex>*/}
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content={`Value(${this.state.caseData.currency}): `} weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.caseValue} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={this.state.caseData.clientType === 'contact' ? <SpeakerPersonIcon /> : <ContentIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Client"
                                    />
                                    <Flex column>
                                        <Text content="Client" weight="bold" />
                                        <Text content={this.state.caseData.clientType === 'contact' ? 'Contact' : 'Company'} size='small' />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Name: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={<a href={new RequestHeaders().url + '/' + (this.state.caseData.clientType === 'contact' ? 'contacts/edit/' : 'companies/tab_company/') + this.state.caseData.contact_company_id} target='_blank'>{this.state.caseData.clientName}</a>} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Email: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            {this.state.caseData.clientEmail?.includes(';') ?
                                                <Flex column>
                                                    {this.state.caseData.clientEmail.split(';').map(email => {
                                                        return (<Segment color='brand' content={
                                                            <Text content={<a href={"mailto: " + email}>{email}</a>} />
                                                        } />);
                                                    })}
                                                </Flex>
                                                :
                                                <Text content={this.state.caseData.clientEmail} />
                                            }
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Phone: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.clientPhoneNumber} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Mobile: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.clientMobileNumber} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<CalendarIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Date & Times"
                                    />
                                    <Flex column>
                                        <Text content="Date & Times" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Arrival Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.caseArrivalDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Due Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.dueDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Closed On: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.closedOn} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<ContactGroupIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Contacts"
                                    />
                                    <Flex column>
                                        <Text content="People" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Assigned Team: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.provider_group_id} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Assignee: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.assignedToFullName} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Referred By: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={<a href={new RequestHeaders().url + '/contacts/edit/' + this.state.caseData.referredBy} target='_blank'>{this.state.caseData.referredByName}</a>} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Requested By: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={<a href={new RequestHeaders().url + '/contacts/edit/' + this.state.caseData.requestedBy} target='_blank'>{this.state.caseData.requestedByName}</a>} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Text content={`*Opening any link will take to ${Helpers.getAppName()}`} />
                    </Flex>
                };
                case CaseType.contract: {
                    return <Flex column hAlign='center' vAlign='center'>
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<InfoIcon />}
                                        label={this.state.caseInfo.type}
                                        name="General Info"
                                    />
                                    <Flex column>
                                        <Text content="General Info" weight="bold" />
                                        <Text content={this.state.caseInfo.type} size="small" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='ID: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.id} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Name: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.name} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Priority: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            {this.state.caseData.priorityId !== undefined ? <Image src={require('../Images/' + this.state.caseData.priorityId + '.png')} styles={{ maxWidth: '20px', maxHeight: '20px' }} /> : <div>-</div>}
                                        </Flex.Item>
                                        <Text content={this.state.caseData.priority} />
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Summary: ' weight='bold' />
                                        </Flex.Item>

                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.summary} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Type: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.type} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Currency: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.currency} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Value: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.value} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Status: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.status} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Reference Number: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.referenceNumber} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<SpeakerPersonIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Parties"
                                    />
                                    <Flex column>
                                        <Text content="Parties" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                {this.state.caseData.parties.map((party, index) => {
                                    return (
                                        <Segment color='brand' content={
                                            <Flex inline gap='gap.medium'>
                                                <Flex vAlign='center' hAlign='center'>
                                                    <Avatar name={String(index + 1)} />
                                                </Flex>
                                                <Flex column>
                                                    <Flex inline gap='gap.medium'>
                                                        <Text content='Type: ' weight='bold' />
                                                        {party.party_member_type === 'contact' ? <SpeakerPersonIcon /> : <ContentIcon />}
                                                        <Text content={party.party_member_type === 'contact' ? 'Contact' : 'Company'} />
                                                    </Flex>
                                                    <Flex inline gap='gap.medium'>
                                                        <Text content='Name: ' weight='bold' />
                                                        <Text content={<a target='_blank' href={new RequestHeaders().url + (party.party_member_type === 'contact' ? '/contacts/edit/' : '/companies/tab_company/') + party.party_member_id}>{party.party_name}</a>} />
                                                    </Flex>
                                                    <Flex inline gap='gap.medium'>
                                                        <Text content='Category: ' weight='bold' />
                                                        <Text content={party.party_category_name} />
                                                    </Flex>
                                                </Flex>
                                            </Flex>} />);
                                })}
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<CalendarIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Date & Times"
                                    />
                                    <Flex column>
                                        <Text content="Date & Times" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Contract Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.contractDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Start Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.startDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='End Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.endDate} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<ContactGroupIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Contacts"
                                    />
                                    <Flex column>
                                        <Text content="People" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Assigned Team: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.assignedTeam} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Assignee: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.assignee} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Contributors: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.contributors} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Collaborators: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.collaborators} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Requested By: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.requester} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Text content={`*Opening any link will take to ${Helpers.getAppName()}`} />
                    </Flex>
                };
                case CaseType.hearing: {
                    return <Flex column hAlign='center' vAlign='center'>
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<InfoIcon />}
                                        label={this.state.caseInfo.type}
                                        name="General Info"
                                    />
                                    <Flex column>
                                        <Text content="General Info" weight="bold" />
                                        <Text content={this.state.caseInfo.type} size="small" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Legal Case Id: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={<a target='_blank' href={new RequestHeaders().url + '/cases/events/' + this.state.caseData.legal_case_id}>{this.state.caseData.legal_case_id}</a>} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Type: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.type.name} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Comments: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.comments} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Summary: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.summary} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Summary To Client: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.summaryToClient} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<AttendeeIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Lawyers"
                                    />
                                    <Flex column>
                                        <Text content="Lawyers" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                {Object.keys(this.state.caseData.hearingLawyersUsers)?.length > 0 ?
                                    Object.keys(this.state.caseData.hearingLawyersUsers).map(key => {

                                        return (
                                            <Segment color='brand' content={
                                                <Flex inline gap='gap.small' vAlign='center'>
                                                    <Avatar name={this.state.caseData.hearingLawyersUsers[key]} />
                                                    <Text content={this.state.caseData.hearingLawyersUsers[key]} />
                                                </Flex>}
                                            />
                                        );
                                    }) :
                                    <Text content='No Lawyers' />
                                }
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<CalendarIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Date & Times"
                                    />
                                    <Flex column>
                                        <Text content="Date & Times" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Start Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.startDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Start Time: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.startTime} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Postponed Date: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.postponedDate} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Postponed Time: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.postponedTime} />
                                        </Flex.Item>
                                    </Flex>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Reasons of Postponement: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.reasons_of_postponement} />
                                        </Flex.Item>
                                    </Flex>
                                </Flex>
                            </CardBody>
                        </Card>
                        <Divider />
                        <Card fluid>
                            <CardHeader>
                                <Flex gap="gap.small">
                                    <Avatar
                                        icon={<MegaphoneIcon />}
                                        label={this.state.caseInfo.type}
                                        name="Judgment"
                                    />
                                    <Flex column>
                                        <Text content="Judgment" weight="bold" />
                                    </Flex>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Flex column gap='gap.small'>
                                    <Flex inline gap='gap.medium'>
                                        <Flex.Item size='size.half'>
                                            <Text content='Judged: ' weight='bold' />
                                        </Flex.Item>
                                        <Flex.Item size='size.half'>
                                            <Text content={this.state.caseData.judged} />
                                        </Flex.Item>
                                    </Flex>
                                    {this.state.caseData.judged === 'no' ? <></> :
                                        <Flex column gap='gap.small'>
                                            <Flex inline gap='gap.medium'>
                                                <Flex.Item size='size.half'>
                                                    <Text content='Judgment: ' weight='bold' />
                                                </Flex.Item>
                                                <Flex.Item size='size.half'>
                                                    <Text content={this.state.caseData.judgment} />
                                                </Flex.Item>
                                            </Flex>
                                            <Flex inline gap='gap.medium'>
                                                <Flex.Item size='size.half'>
                                                    <Text content='Judgment Value: ' weight='bold' />
                                                </Flex.Item>
                                                <Flex.Item size='size.half'>
                                                    <Text content={this.state.caseData.judgmentValue} />
                                                </Flex.Item>
                                            </Flex>
                                            <Flex inline gap='gap.medium'>
                                                <Flex.Item size='size.half'>
                                                    <Text content='Judgment Currency: ' weight='bold' />
                                                </Flex.Item>
                                                <Flex.Item size='size.half'>
                                                    <Text content={this.state.caseData.judgmentValueCurrency} />
                                                </Flex.Item>
                                            </Flex>
                                        </Flex>
                                    }
                                </Flex>
                            </CardBody>
                        </Card>
                        <Text content={`*Opening any link will take to ${Helpers.getAppName()}`} />
                    </Flex>
                };
                default: return <Text content='No Data' />;
            }
        };
        const getInvalidChannelMessage = () => {
            switch(this.state.invalidityReasson){
                case 'invalidRecord': {
                    return "Record not found! you may have no access to it or it has been deleted. For more information, contact your administrator!"
                }
                default: {
                    return "This Channel is not linked to a matter, a contract, or a hearing! Go to personal app and create any matter/contract/hearing” to get started with the app."
                }
            }
        }
        return (
            this.state.isLoading ? <Loader label="Loading channel details..." /> :
                (this.state.validChannel ?
                    <Flex inline={!this.props.isMobile} column={this.props.isMobile} gap='gap.small' styles={{ width: '100%', marginBottom: '40px' }}>
                        <Flex.Item size='size.half'>
                            <Segment color='brand'
                                content={<Flex column styles={{ width: '100%' }}>
                                    <Flex inline hAlign='start' vAlign='start' gap='gap.medium' styles={{ width: '100%' }}>
                                        <Flex inline gap='gap.small'>
                                            {this.state.caseInfo.type !== undefined && <Image src={require('../Images/' + Functions.getCaseDetailsImage(this.state.caseInfo.type) + '.png')} styles={{ width: '40px', height: '40px' }} />}
                                            <Header
                                                as="h6"
                                                content={this.state.caseInfo.type}
                                                description={{
                                                    content: 'Details',
                                                    as: 'span',
                                                }}
                                            />
                                        </Flex>
                                        {this.state.caseInfo.type == CaseType.hearing ? <div /> :
                                            <Flex.Item push>
                                                <Button icon={<OpenOutsideIcon />} content={{ content: `Manage in ${Helpers.getAppName()}`, size: 'small' }} iconPosition="before" secondary onClick={
                                                    (e) => {
                                                        e.preventDefault();
                                                        var caseUrl = new RequestHeaders().url;
                                                        switch (this.state.caseInfo.type) {
                                                            case CaseType.litigation: case CaseType.matter: {
                                                                caseUrl += '/cases/edit/' + this.state.caseInfo.id;
                                                            } break;
                                                            case CaseType.contract: {
                                                                caseUrl += '/modules/contract/contracts/view/' + this.state.caseInfo.id;
                                                            } break;
                                                        }
                                                        window.open(caseUrl);
                                                    }} />
                                            </Flex.Item>
                                        }
                                    </Flex>
                                    <div style={{ marginTop: '15px' }}>
                                        {this.state.caseData ? caseForm() : <Loader />}
                                    </div>
                                </Flex>}
                            />
                        </Flex.Item>
                        <Flex.Item size='size.half'>
                            <Flex column hAlign='start' vAlign='start' gap='gap.small'>
                                <Flex.Item>
                                    <Segment color='brand' styles={{ overflow: 'auto', width: '100%' }}
                                        content={
                                            <Flex column vAlign='stretch' hAlign='center'>
                                                <Flex inline hAlign='start' vAlign='start' gap='gap.small' styles={{ width: '100%' }}>
                                                    <Flex.Item grow>
                                                        <Flex inline>
                                                            <NotesIcon size='larger' styles={({ theme: { siteVariables } }) => ({
                                                                color: siteVariables.colorScheme?.brand?.foreground,
                                                            })} />
                                                            <Header
                                                                as="h6"
                                                                content='Export Conversations'
                                                                description={{
                                                                    content: 'Note',
                                                                    as: 'span',
                                                                }}
                                                            />
                                                        </Flex>
                                                    </Flex.Item>
                                                    <Flex.Item push>
                                                        <div>
                                                            <Tooltip content='Export channel conversation as Note to the related case' trigger={<Button icon={<InfoIcon />} iconOnly />} />
                                                        </div>
                                                    </Flex.Item>
                                                </Flex>
                                                <Flex column hAlign='center' vAlign='center' styles={{ marginTop: '15px', width: '100%' }}>
                                                    <Form onSubmit={this.handleSubmitExpConversation}>
                                                        <FormInput fluid label='Note title' name='noteTitle' required
                                                            onChange={(e, props) => {
                                                                noteTitle = props.value;
                                                            }}
                                                        />
                                                        <FormRadioGroup label='Exportation method'
                                                            defaultCheckedValue='full' items={items}
                                                            onCheckedValueChange={(e, props) => {
                                                                fullOrSync = props.name;
                                                            }
                                                            }
                                                        />
                                                        {this.state.isSendingConversations ? <Loader /> :
                                                            <FormButton primary disabled={this.state.isLoading} fluid content='Submit' />
                                                        }
                                                    </Form>
                                                </Flex>
                                            </Flex>
                                        }
                                    />
                                </Flex.Item>
                                <Flex.Item>
                                    <Segment color='brand' styles={{ overflow: 'auto', width: '100%' }}
                                        content={
                                            <Flex column vAlign='stretch' hAlign='center'>
                                                <Flex.Item grow>
                                                    <Flex column hAlign='center' vAlign='center' styles={{ width: '100%' }}>
                                                        <Flex inline hAlign='start' vAlign='start' gap='gap.small' styles={{ width: '100%' }}>
                                                            <Flex.Item grow>
                                                                <Flex inline>
                                                                    <PaperclipIcon size='larger' styles={({ theme: { siteVariables } }) => ({
                                                                        color: siteVariables?.colorScheme?.brand?.foreground,
                                                                    })} />
                                                                    <Header
                                                                        as="h6"
                                                                        content='Export Files'
                                                                        description={{
                                                                            content: 'Related Documents',
                                                                            as: 'span',
                                                                        }}
                                                                    />
                                                                </Flex>
                                                            </Flex.Item>
                                                            <Flex.Item push>
                                                                <div>
                                                                    <Tooltip content='Export channel files as Attachments to the related case' trigger={<Button icon={<InfoIcon />} iconOnly />} />
                                                                </div>
                                                            </Flex.Item>
                                                        </Flex>
                                                        {this.state.isLoadingFiles ? <FilesSkeleton /> :

                                                            <Flex column hAlign='center' vAlign='center' styles={{ overflow: 'auto', margin: '15px auto', maxHeight: '550px', width: '100%' }}>
                                                                {channelFiles.length > 0 ?
                                                                    channelFiles.map((file, index) => {
                                                                        return (
                                                                            <Attachment styles={{ margin: '5px auto', marginTop: (index == 0 ? '30px' : '5px') }}  {...file} />
                                                                        );
                                                                    })
                                                                    :
                                                                    <Text content={this.state.filesStatus} />}
                                                            </Flex>
                                                        }
                                                    </Flex>
                                                </Flex.Item>
                                                <Flex.Item push>
                                                    {this.state.isSendingFiles ? <Loader /> :
                                                        <Button primary fluid content='Export Files' disabled={!this.state.didAnyFileSelected} onClick={this.handleSubmitExpFiles} />
                                                    }
                                                </Flex.Item>
                                            </Flex>}
                                    />
                                </Flex.Item>
                            </Flex>
                        </Flex.Item>
                        <Dialog
                            open={this.state.openDialog}
                            header='Information'
                            content={dialogMessage}
                            confirmButton={null}
                            cancelButton="Cancel"
                            onCancel={() => {
                                this.setState({ openDialog: false })
                            }}
                        />
                    </Flex> : <Header align='center' color='red' content={getInvalidChannelMessage()} />)

        );
    }
}
export default ChannelTabComponent;
const FilesSkeleton = () => {
    return (
        <Flex column gap='gap.medium' styles={{ width: '100%' }}>
            <Skeleton animation="pulse">
                <Flex inline vAlign='center' hAlign='center' gap='gap.medium' styles={{ width: '100%' }}>
                    <Skeleton.Shape round height='20px' width='20px' />
                    <Skeleton.Line width='80%' />
                </Flex>
            </Skeleton>
            <Skeleton animation="pulse">
                <Flex inline vAlign='center' hAlign='center' gap='gap.medium' styles={{ width: '100%' }}>
                    <Skeleton.Shape round height='20px' width='20px' />
                    <Skeleton.Line width='80%' />
                </Flex>
            </Skeleton>
            <Skeleton animation="pulse">
                <Flex inline vAlign='center' hAlign='center' gap='gap.medium' styles={{ width: '100%' }}>
                    <Skeleton.Shape round height='20px' width='20px' />
                    <Skeleton.Line width='80%' />
                </Flex>
            </Skeleton>
            <Skeleton animation="pulse">
                <Flex inline vAlign='center' hAlign='center' gap='gap.medium' styles={{ width: '100%' }}>
                    <Skeleton.Shape round height='20px' width='20px' />
                    <Skeleton.Line width='80%' />
                </Flex>
            </Skeleton>
        </Flex>
    )
}
interface ITabState {
    isLoading: boolean;
    loaderLabel: string;
    openDialog: boolean;
    type: string;
    caseInfo: any;
    caseData: any;
    validChannel: boolean;
    invalidityReasson: string;
    isSendingConversations: boolean;
    isSendingFiles: boolean;
    isLoadingFiles: boolean;
    didAnyFileSelected: boolean;
    filesStatus: string;
}
interface ITabProps {    
    redirectPage: string;
    executeDeepLink(link);
    isMobile: boolean;
}